module.exports = __webpack_public_path__ + "img/4-3.b94e563c.png";